const staticHost = process.env.VUE_APP_STATIC_HOST
const hosts = {
  static(url) {
    if (!url) return null

    // 以 http 开头的 url 或 base64 字符串，直接返回
    if (url.startsWith('http') || url.startsWith('data:image')) {
      return url
    }
    url = /^\//.test(url) ? url : `/${url}`
    return `${staticHost}${url}`
  }
}
export default {
  hosts,
  install: (Vue) => {
    Vue.prototype.$hosts = hosts
  }
}
